import React, { memo } from 'react';
import classNames from 'classnames';
import { animated, SpringRef, to } from '@react-spring/web';

import type {
  TPageContentItem,
} from '../../types/wysiwyg_editor';

import ErrorBoundary from '@src/components/ErrorBoundary';
import { has } from '@src/utils/typescript';
import { SprungRect } from '@src/types/misc';

const PageContentItem = memo(function PageContentItem({
  data,
  children,
  frameViewboxSpringValues
}: {
    data: TPageContentItem;
    children: React.ReactElement;
    frameViewboxSpringValues: SprungRect;
  }) {
    return (
      <ErrorBoundary fallback={false}>
        <animated.g
          className={classNames('page-content-item', has('class', data) ? data.class : '')}
          transform={to(
            [frameViewboxSpringValues.x, frameViewboxSpringValues.y],
            (x, y) => {
              return `translate(${x} ${y})`;
            }
          )}
        >
          {children}
        </animated.g>
      </ErrorBoundary>
    );
  });

export default PageContentItem;
